<template>
  <div class="tabbar7">
    <div v-for="item in navData" class="tabbar_item" @click="tapItem(item)">
      <div class="marks" v-if="item.pagename=='chat'&&unReadCount">{{unReadCount}}</div>
      <div class="tabbar_icon">
        <img :src="item.ico" />
      </div>
      <span class="tabbar_text" :class="{yes:item.isActive}">{{item.name}}</span>
    </div>
    <ShareGuide v-if="isShowShareGuide" v-on:close="closeShareGuide"></ShareGuide>
    <FocusGuide v-if="isShowFocusGuide" v-on:close="closeFocusGuide" :my="showImg"></FocusGuide>
    <ZxslzxXcxShare v-if="isShowZxslzxXcxShare" v-on:close="closeZxslzxXcxShare"></ZxslzxXcxShare>
    <HdkShareGuide v-if="isShowHdkShareGuide" v-on:close="closeHdkShareGuide"></HdkShareGuide>
  </div>
</template>
<script>
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
const ShareGuide = () => import("@/components/share_guide4.vue");
const FocusGuide = () => import("@/components/focus_guide.vue");
const ZxslzxXcxShare = () => import("@/components/zxslzx-xcx-share.vue");
const HdkShareGuide = () => import("@/components/hdk-share_guide.vue");

import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
import Cookies from "js-cookie";
import global_ from "./../global.config";
import utils from "@/utils/utils";
export default {
  components: {
    ShareGuide,
    FocusGuide,
    ZxslzxXcxShare,
    HdkShareGuide,
  },
  props: {},
  data() {
    return {
      isShowShareGuide: false, //是否显示分享
      isShowFocusGuide: false, //是否显示关注
      isShowZxslzxXcxShare: false, //小程序环境下展示
      isShowHdkShareGuide: false,
      //底部导航
      navData: [],
      showImg: {
        isShow: false,
        url: "",
        width: "",
        intro: "",
      },
      unReadCount: 0,
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "receiveSpreadInfo",
    ]),
  },
  methods: {
    // 关闭网页分享引导
    closeShareGuide() {
      this.isShowShareGuide = false;
      this.activeItem({ pagename: this.$route.name });
    },
    // 关闭关注提示
    closeFocusGuide() {
      this.isShowFocusGuide = false;
      this.activeItem({ pagename: this.$route.name });
    },
    closeZxslzxXcxShare(callback) {
      this.isShowZxslzxXcxShare = false;
      if (callback) {
        callback();
      }
    },
    closeHdkShareGuide() {
      this.isShowHdkShareGuide = false;
    },
    tapItem(item) {
      let that = this;
      if (item.pagename == "t9_my") {
        console.log(Cookies.get("isAuth"));
        if (Cookies.get("isAuth") == 1) {
          console.log(global_.APPID);
          Cookies.remove("openid");
          Cookies.remove("isAuth");
          Cookies.remove("fake");
          Cookies.remove("passport");
          let url = utils.getUrlRemoveParams(location.href);
          let params = utils.getParamFromUrl(location.href);
          console.log(url);
          console.log(params);
          delete params.isAuth;
          delete params.xcxGzhOpenid;
          delete params.xcxGzhPassport;
          let cbackUrl=utils.addUrlParamFromObj(url,params)
          console.log(cbackUrl)
          let auth_url = `${global_.API_URL}?appid=${
            global_.APPID
          }&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(cbackUrl)}`;
          console.log(auth_url);
          // debugger;
          window.location.href = auth_url;
        }
      }
      this.activeItem(item);
      if (item.type == "link") {
        // lj12
        if (this.$route.name == item.pagename) {
          return;
        }
        if (
          util.checkIsHuafa() ||
          (this.isInMiniProgram && !util.checkIsHaveOldMp())
        ) {
          if (item.pagename == "t9_my") {
            util.checkMapStateCallback(this, ["userInfo"]).then(() => {
              if (
                this.userInfo &&
                this.userInfo.fansInfo &&
                (this.userInfo.fansInfo.mobile ||
                  this.userInfo.fansInfo.ui_mobile)
              ) {
                // 有电话
                this.$router.push(`/${item.pagename}`);
              } else {
                // 无电话
                util.openYqRsMakeLink(
                  `${location.protocol}//${location.host}/h5/${item.pagename}`
                );
              }
            });
          } else {
            this.$router.push(`/${item.pagename}`);
          }
        } else {
          this.$router.push(`/${item.pagename}`);
        }
      } else if (item.type == "op") {
        if (
          location.href.indexOf("/qmyx/") > -1 &&
          item.pagename == "tuijian"
        ) {
          return;
        }

        if (item.pagename == "share") {
          // lj13
          if (this.isInMiniProgram) {
            // 小程序中也不走客服消息分享了
            if (this.isShowGuide && false) {
              this.isShowZxslzxXcxShare = true;
            } else {
              this.isShowHdkShareGuide = true;
            }
          } else {
            this.activeItem(item);
            this.isShowShareGuide = true;
          }
        } else if (item.pagename == "focus") {
          // lj14
          this.activeItem(item);
          this.isShowFocusGuide = true;
        } else if (item.pagename == "tuijian") {
          // if(util.checkIsHuafaTest()) {
          //   let url = `${location.protocol}//${location.host}/huafa/qmyx/client-backup`
          //   util.openUrl(url);
          // } else {
          //   // 微信标识_操作_电话_项目id_在线售楼openid_城市
          //   let mobile = util.getUserMobile(this.userInfo);

          //   let backurl = `${location.protocol}//${location.host}/h5/`;
          //   if (location.href.indexOf("t9_my") > -1) {
          //     backurl += "t9_my";
          //   } else if (location.href.indexOf("t9_project") > -1) {
          //     backurl += "t9_project";
          //   } else {
          //     backurl += "t9";
          //   }
          //   let url = util.getHfYxUrl("recommend", mobile, "", backurl);
          //   util.openUrl(url);
          // }
          util.checkMapStateCallback(this, ["userInfo"]).then(() => {
            let agentTel = util.getUserMobile(this.userInfo);
            if (!agentTel) {
              agentTel = "X";
            }
            comreq
              .checkIsYxUser(
                // `${this.global.HF_YXCONFIG.api}/${agentTel}/${Cookies.get("openid")}`
                `${
                  this.global.HF_YXCONFIG.apiurl
                }agentAccount/loginByCityOpenId/${Cookies.get("openid")}`
              )
              .then((res) => {
                if (res.code == "200" && res.data && res.data.id) {
                  this.$router.push("/qmyx/client-backup");
                } else {
                  this.$router.push("/qmyx/agent-auth");
                }
              });
          });
        } else if (item.pagename == "chat") {
          // 咨询
          // 先进入兑换列表页面
          that.$router.push("/chat_list");
        }
      }
    },
    // 激活按钮
    activeItem(item) {
      if (item.isActive == true) {
        return;
      }
      this.navData.forEach((element) => {
        if (
          element.pagename == item.pagename ||
          (element.pagename == "chat" && this.$route.name == "chat_list") ||
          (element.pagename == "chat" && this.$route.name == "chat_dialog")
        ) {
          element.ico = element.yes;
          element.isActive = true;
        } else if (
          location.href.indexOf("/qmyx/") > -1 &&
          element.pagename == "tuijian"
        ) {
          element.ico = element.yes;
          element.isActive = true;
        } else {
          element.ico = element.no;
          element.isActive = false;
        }
      });
    },
  },
  created() {
    if (this.$route.name != "chat_list") {
      setInterval(() => {
        comreq.chatGetUnreadMsg().then((noReadList) => {
          if (noReadList) {
            this.unReadCount = noReadList.length > 99 ? 99 : noReadList.length;
          }
        });
      }, 3000);
    }
  },
  mounted() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      let navData = [];
      if (util.checkIsHuafa()) {
        navData = [
          {
            name: "首页",
            pagename: "t9",
            type: "link",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_xiangmu_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_xiangmu_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_xiangmu_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          },
          {
            name: "楼盘",
            pagename: "t9_project",
            type: "link",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_loupan_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_loupan_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_loupan_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          },
          {
            name: "推荐",
            pagename: "tuijian",
            type: "op",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_tuijian_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_tuijian_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_tuijian_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          },
          {
            name: "我的",
            pagename: "t9_my",
            type: "link",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_wode_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_wode_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_wode_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          },
        ];
      } else {
        navData = [
          {
            name: "首页",
            pagename: "t9",
            type: "link",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/shouye0407_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/shouye0407_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/shouye0407_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          },
        ];
        if (util.checkIsTest() || util.checkIsAlej()) {
          if (Cookies.get("isAuth") != 1) {
            navData.push({
              name: "咨询",
              pagename: "chat",
              type: "op",
              ico:
                "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/zixun0407_no.png?x-oss-process=image/resize,h_100,w_100",
              no:
                "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/zixun0407_no.png?x-oss-process=image/resize,h_100,w_100",
              yes:
                "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/zixun0407_yes.png?x-oss-process=image/resize,h_100,w_100",
              isActive: false,
            });
          }
        }
        navData.push({
          name: "分享",
          pagename: "share",
          type: "op",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/fenxiang0407_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/fenxiang0407_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/fenxiang0407_yes.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false,
        });
        if (
          !this.isInMiniProgram &&
          this.pageInfo &&
          this.pageInfo.WxQrcode &&
          !util.checkIsTest()
        ) {
          navData.push({
            name: "关注",
            pagename: "focus",
            type: "op",
            ico:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_guanzhu_no.png?x-oss-process=image/resize,h_100,w_100",
            no:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_guanzhu_no.png?x-oss-process=image/resize,h_100,w_100",
            yes:
              "https://assets.rurushishi.com/yq-rs-make/t9/tabbar7_guanzhu_yes.png?x-oss-process=image/resize,h_100,w_100",
            isActive: false,
          });
          this.showImg = {
            url: this.pageInfo.WxQrcode,
            width: "80%",
            intro: "请长按扫码关注！",
            isShow: true,
          };
        }
        navData.push({
          name: "我的",
          pagename: "t9_my",
          type: "link",
          ico:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/wode0407_no.png?x-oss-process=image/resize,h_100,w_100",
          no:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/wode0407_no.png?x-oss-process=image/resize,h_100,w_100",
          yes:
            "https://assets.rurushishi.com/yq-rs-make/components/tabbar7/wode0407_yes.png?x-oss-process=image/resize,h_100,w_100",
          isActive: false,
        });
      }

      this.navData = navData;

      this.activeItem({ pagename: this.$route.name });
    });
  },
};
</script>
<style lang="css" scoped>
/* 底部导航 */
.tabbar7 {
  width: 100%;
  height: 1.2rem;
  /* background: #fff; */
  /* background: #f5af19; */
  /* background: linear-gradient(to right, #f5af19, #f12711); */
  /* background: linear-gradient(to right, #4CB8E9, #007DA6); */
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-top: 1px solid #c6c6c6;
}

.tabbar_item {
  flex: 1;
  text-align: center;
  position: relative;
  height: 1.2rem;
}

.tabbar_icon {
  padding-top: 0.2rem;
  width: 100%;
}

.tabbar_icon > img {
  width: 0.5rem;
  height: 0.5rem;
}

.tabbar_text {
  padding-top: 0.1rem;
  display: inline-block;
  color: #4e4e4e;
  font-size: 0.2rem;
}
.tabbar_text.yes {
  color: #ff811b;
}
.tabbar_item .marks {
  position: absolute;
  top: 0.10135819987837rem;
  left: 1.2rem;
  width: 0.324346239610785rem;
  height: 0.324346239610785rem;
  line-height: 0.324346239610785rem;
  background: #f00;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  font-size: 0.243259679708088rem;
}
</style>